(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dillz-contact-policies"]) return;
  try {
    
  (() => {
    const policies = document.getElementById('policies');
    if (!policies || !policies.classList.contains('dillz-contact-policies')) return;
    const embedSection = policies.closest('.shopify-section')?.previousElementSibling;
    let observer;
    let settleTimer;
    let limitTimer;
    let alignmentTimer;
    let following = false;
    const stopFollowing = () => {
      following = false;
      observer?.disconnect();
      clearTimeout(settleTimer);
      clearTimeout(limitTimer);
      clearInterval(alignmentTimer);
    };
    const alignPolicies = () => {
      if (following && window.location.hash === '#policies') {
        policies.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    };
    const startFollowing = () => {
      stopFollowing();
      if (window.location.hash !== '#policies') return;
      following = true;
      observer = new ResizeObserver(() => {
        alignPolicies();
        clearTimeout(settleTimer);
        if (embedSection?.querySelector('iframe')?.getBoundingClientRect().height > 300) {
          settleTimer = setTimeout(stopFollowing, 3000);
        }
      });
      if (embedSection) observer.observe(embedSection);
      limitTimer = setTimeout(stopFollowing, 20000);
      alignmentTimer = setInterval(alignPolicies, 250);
      requestAnimationFrame(alignPolicies);
    };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, stopFollowing, { passive: true });
    });
    window.addEventListener('hashchange', startFollowing);
    window.addEventListener('load', alignPolicies, { once: true });
    startFollowing();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
if (!customElements.get('dillz-cart-checkout')) {
  customElements.define('dillz-cart-checkout', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      const cart = this.closest('.dillz-cart');
      const checkout = cart.querySelector('.cart__checkout-button');
      let cartVisible = false;
      let checkoutVisible = false;
      this.observeVisibility = () => {
        this.observer?.disconnect();
        const shipping = cart.querySelector('.dillz-cart__shipping-top');
        const styles = shipping && getComputedStyle(shipping);
        const topOffset = styles?.position === 'sticky' ? (parseFloat(styles.top) || 0) + shipping.offsetHeight : 0;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === cart) cartVisible = entry.isIntersecting;
            if (entry.target === checkout) checkoutVisible = entry.intersectionRatio >= 1;
          });
          this.hidden = !cartVisible || checkoutVisible;
        }, { threshold: [0, 1], rootMargin: `-${topOffset}px 0px 0px 0px` });
        this.observer.observe(cart);
        this.observer.observe(checkout);
      };
      this.observeVisibility();
      window.addEventListener('resize', this.observeVisibility);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.observeVisibility);
    }
  });
}
if (!customElements.get('dillz-cart-picks')) {
  customElements.define('dillz-cart-picks', class extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const productIds = JSON.parse(this.dataset.products || '[]');
      const cartTypes = new Set(JSON.parse(this.dataset.productTypes || '[]').map(type => String(type).trim().toLowerCase()));
      if (!productIds.length) return;
      const responses = await Promise.allSettled(productIds.slice(0, 3).map(async (id) => {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('product_id', id);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');
        url.searchParams.set('section_id', 'dillz-cart-picks');
        const response = await fetch(url, {signal: AbortSignal.timeout(8000)});
        if (!response.ok) throw new Error('Recommendations unavailable');
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      }));
      if (!this.isConnected) return;
      const cards = new Map();
      responses.forEach((response) => {
        if (response.status !== 'fulfilled') return;
        response.value.querySelectorAll('.dillz-cart-pick').forEach((card) => {
          const id = Number(card.dataset.productId);
          const type = (card.dataset.productType || '').trim().toLowerCase();
          if (type && !cartTypes.has(type) && !productIds.includes(id) && !cards.has(id)) cards.set(id, card);
        });
      });
      const remaining = Number(this.dataset.remaining);
      const ranked = [...cards.values()];
      if (remaining > 0) {
        ranked.sort((a, b) => {
          const aPrice = Number(a.dataset.price), bPrice = Number(b.dataset.price);
          const aFits = aPrice >= remaining, bFits = bPrice >= remaining;
          if (aFits !== bFits) return aFits ? -1 : 1;
          return Math.abs(aPrice - remaining) - Math.abs(bPrice - remaining);
        });
      }
      if (!ranked.length) return;
      const suggestedTypes = new Set();
      const complementary = ranked.filter(card => {
        const type = card.dataset.productType.trim().toLowerCase();
        if (suggestedTypes.has(type)) return false;
        suggestedTypes.add(type);
        return true;
      });
      const selected = complementary.slice(0, 2);
      if (remaining > 0 && Number(complementary[0].dataset.price) >= remaining) {
        const lowerPriceOption = complementary.find(card => Number(card.dataset.price) < remaining);
        if (lowerPriceOption) selected[1] = lowerPriceOption;
      }
      this.querySelector('.dillz-cart-picks__list').replaceChildren(...selected);
      this.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
